package top.wcpe.allincore.ui.runtime.render

import top.wcpe.allincore.ui.runtime.render.model.CursorType

/**
 * 光标回调接缝（JS actual）：把 [CursorType] 映射为 CSS cursor 值写到 `document.body.style.cursor`
 * （FR-UI-025 hover 链路——与 fabric 用 GLFW 标准指针同语义，浏览器端用 CSS 标准光标）。
 *
 * 注意：ui-runtime 的 js target 是 nodejs（jsTest 环境无 document），故 document 只在
 * [JsCursorSink.setCursor] 方法体内经 `js()` 惰性访问——Node 下不触发输入分发即不求值，
 * 浏览器（web-preview）下正常生效。
 */
private object JsCursorSink : CursorSink {
    override fun setCursor(type: CursorType) {
        val css = toCss(type)
        js("document.body.style.cursor = css")
    }

    /** [CursorType] → CSS cursor 关键字（与真源枚举语义一一对应，均为 CSS 标准值）。 */
    private fun toCss(type: CursorType): String = when (type) {
        CursorType.DEFAULT -> "default"
        CursorType.POINTER -> "pointer"
        CursorType.TEXT -> "text"
        CursorType.MOVE -> "move"
        CursorType.RESIZE_H -> "ew-resize"
        CursorType.RESIZE_V -> "ns-resize"
        CursorType.RESIZE_NWSE -> "nwse-resize"
        CursorType.RESIZE_NESW -> "nesw-resize"
        CursorType.NOT_ALLOWED -> "not-allowed"
        CursorType.WAIT -> "wait"
    }
}

internal actual fun cursorSink(): CursorSink = JsCursorSink
